module.exports = __webpack_public_path__ + "img/add_logo.5b9394c7.svg";